import React, { Component } from 'react'
import styled from 'styled-components'
import Logic from './logic'
import { Grid } from 'react-flexbox-grid'

@Logic
class App extends Component {
  componentDidUpdate() {
    this.sendHeight()
    window.addEventListener('resize', this.sendHeight)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sendHeight)
  }

  sendHeight = () => {
    const height = document.body.scrollHeight
    window.parent.postMessage({ type: 'setHeight', height }, '*')
  }
  render() {
    return (
      <Wrapper>
        <Anchor id='anchor' />
        {!this.props.loading && this.props.children}
      </Wrapper>
    )
  }
}

export default App

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`

export const Container = styled(Grid)`
  max-width: 1200px;
  margin: 0 auto;
`

const Anchor = styled.div``



// WEBPACK FOOTER //
// ./src/containers/App/index.js